// Widget CSS
import '@/css/_elementor/widgets/card_subscribe.css';

// ..........................................................................................

import { ShuffleColors } from '@/js/utilities/color-shuffle';

// ..........................................................................................

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/card_subscribe.default', (scope) => {
		const scopeEl = scope[0];

		if (!scopeEl) return;

		// ......................................................

		setTimeout(() => {
			new ShuffleColors({
				container: scopeEl,
				colors: ['#FBE88C', '#B0EAC3', '#C9D0FC', '#94C3FC'],
			});
		}, 350);

		//
	});
});
